"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var actions = require("@caddigital/sok-reducers/lib/actions/project/customerUserGroups");
require("./LinkCustomerGroupModal.scss");
var mapStateToProps = function (state) {
    return {
        customerUserGroups: state.project.customerUserGroups
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    toggleModal: function () { return dispatch(actions.toggleModal()); },
    clear: function () { return dispatch(actions.clear()); },
    select: function (group) { return dispatch(actions.setSelected(group)); },
    fetch: function (customerId) { return dispatch(actions.fetchRequest(customerId)); },
    link: function (project, group) {
        return dispatch(actions.linkRequest(project, group));
    }
}); };
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        if (this.props.customerUserGroups.isOpen &&
            this.props.currentProject.customerId !== undefined) {
            this.props.fetch(this.props.currentProject.customerId);
        }
    },
    componentDidUpdate: function (prevProps) {
        if (this.props.customerUserGroups.isOpen &&
            this.props.customerUserGroups.isOpen !==
                prevProps.customerUserGroups.isOpen &&
            this.props.currentProject.customerId !== undefined) {
            this.props.fetch(this.props.currentProject.customerId);
        }
        if (!this.props.customerUserGroups.isOpen &&
            this.props.customerUserGroups.isOpen !==
                prevProps.customerUserGroups.isOpen) {
            this.props.clear();
        }
    },
    shouldComponentUpdate: function (nextProps) {
        if (nextProps.customerUserGroups.isOpen ||
            this.props.customerUserGroups.isOpen !==
                nextProps.customerUserGroups.isOpen) {
            return true;
        }
        return false;
    }
}), recompose_1.pure);
exports.default = enhance(function (props) { return (React.createElement(sok_ui_1.Modal, { isOpen: props.customerUserGroups.isOpen, className: 'link-customer-usergroup-to-project-modal' },
    React.createElement(sok_ui_1.Header, { onClose: props.toggleModal }, (0, translation_1.getLocalization)('components/modals/link-customer-usergroup')),
    React.createElement(sok_ui_1.Container, null,
        React.createElement("div", { className: 'content' },
            React.createElement(sok_ui_1.RequestStatusBox, { status: props.customerUserGroups.linkStatus, statusList: ['STANDBY', 'SAVING', 'SAVED', 'FAILED'] },
                (0, translation_1.getLocalization)('components/modals/link-customer-usergroup/linking'),
                (0, translation_1.getLocalization)('components/modals/link-customer-usergroup/linked'),
                (0, translation_1.getLocalization)('components/modals/link-customer-usergroup/failed')),
            React.createElement("div", { className: 'column' },
                React.createElement("label", null, (0, translation_1.getLocalization)('components/modals/link-customer-usergroup/selectCategory')),
                React.createElement(sok_ui_1.Dropdown2, { className: 'selector', alignment: 'left' },
                    React.createElement(sok_ui_1.TextInput, { editable: false, value: props.customerUserGroups.selected &&
                            props.customerUserGroups.selected.name !== ''
                            ? props.customerUserGroups.selected.name
                            : (0, translation_1.getLocalization)('components/modals/link-customer-usergroup/placeholder'), iconRight: React.createElement("span", { className: 'icon-container' },
                            React.createElement(Icon_1.Icon, { className: 'fa-chevron-down' })) }),
                    React.createElement(sok_ui_1.Dropdown2Menu, null, props.customerUserGroups.groups.map(function (z, key) {
                        return (React.createElement(sok_ui_1.Dropdown2MenuItem, { key: key, selected: props.customerUserGroups.selected
                                ? props.customerUserGroups.selected.id === z.id
                                : false, onClick: function () { return props.select(z); } }, z.name));
                    })))))),
    React.createElement(sok_ui_1.Footer, null,
        React.createElement(sok_ui_1.Button, { color: 'green', disabled: props.customerUserGroups.linkStatus === 'FETCHING' ||
                !props.customerUserGroups.selected, onClick: function () {
                return props.customerUserGroups.selected !== null &&
                    props.link(props.currentProject, props.customerUserGroups.selected);
            }, iconRight: React.createElement(Icon_1.Icon, { className: 'fa-plus-circle' }), text: (0, translation_1.getLocalization)('buttons/add') }),
        React.createElement(sok_ui_1.Button, { color: 'dark-gray', onClick: props.toggleModal, iconRight: React.createElement(Icon_1.Icon, { className: 'fa-times-circle' }), text: (0, translation_1.getLocalization)('buttons/cancel') })))); });
